<div class="container">
  <img
    src="/wealth-assets/svg/bg-notify-me.svg"
    alt="خبرم کن!"
  />
  <span> میخواهید از فرصت‌های سرمایه‌گذاری جدید با خبر شوید؟ </span>

  <ngx-button
    [style]="'fill'"
    (clickHandler)="notifyMe()"
    size="small"
    [isLoading]="loading"
    [rightIcon]="{ name: 'notification', type: 'linear' }"
  >
    خبرم کن!
  </ngx-button>
</div>
